/**
 * Form schema types — domain-agnostic V1 contract for app form-engine.
 * Schema describes WHAT; engine decides HOW.
 */

export type FormFieldType = 'text' | 'email' | 'phone' | 'textarea';

export type FieldValidation = {
  required?: boolean;
  minLength?: number;
  maxLength?: number;
};

export type FieldLayout = {
  xs?: number;
  md?: number;
};

export type FormField = {
  name: string;
  type: FormFieldType;
  labelKey?: string;
  placeholderKey?: string;
  /** Explicit rules only. Type does NOT imply required. */
  validation?: FieldValidation;
  rows?: number;
  layout?: FieldLayout;
};

export type FormSection = {
  id: string;
  titleKey?: string;
  layout?: 'row' | 'column';
  fields: FormField[];
};

export type FormSchema = {
  name: string;
  sections: FormSection[];
};

export function flattenSchemaFields(schema: FormSchema): FormField[] {
  return schema.sections.flatMap((section) => section.fields);
}
